// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { MceEventClassSet, MceEventClassSetT, verifyMceEventClassSet } from "./mce-event-class-set";
import { EventKey, EventKeyT } from "../mce/event-key";

/**
 * PATCH: several sets and resets, applied atomically in one rebuild.
 */
export class MceEventClassBatch implements flatbuffers.IUnpackableObject<MceEventClassBatchT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MceEventClassBatch {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMceEventClassBatch(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassBatch,
  ): MceEventClassBatch {
    return (obj || new MceEventClassBatch()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsMceEventClassBatch(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassBatch,
  ): MceEventClassBatch {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MceEventClassBatch()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  set(index: number, obj?: MceEventClassSet): MceEventClassSet | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new MceEventClassSet()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  setLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  reset(index: number, obj?: EventKey): EventKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new EventKey()).__init(
          this.bb!.__vector(this.bb_pos + offset) + index * 8,
          this.bb!,
        )
      : null;
  }

  resetLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startMceEventClassBatch(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addSet(builder: flatbuffers.Builder, setOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, setOffset, 0);
  }

  static createSetVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSetVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addReset(builder: flatbuffers.Builder, resetOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, resetOffset, 0);
  }

  static startResetVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4);
  }

  static endMceEventClassBatch(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createMceEventClassBatch(
    builder: flatbuffers.Builder,
    setOffset: flatbuffers.Offset,
    resetOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MceEventClassBatch.startMceEventClassBatch(builder);
    MceEventClassBatch.addSet(builder, setOffset);
    MceEventClassBatch.addReset(builder, resetOffset);
    return MceEventClassBatch.endMceEventClassBatch(builder);
  }

  unpack(): MceEventClassBatchT {
    return new MceEventClassBatchT(
      this.bb!.createObjList<MceEventClassSet, MceEventClassSetT>(
        this.set.bind(this),
        this.setLength(),
      ),
      this.bb!.createObjList<EventKey, EventKeyT>(this.reset.bind(this), this.resetLength()),
    );
  }

  unpackTo(_o: MceEventClassBatchT): void {
    _o.set = this.bb!.createObjList<MceEventClassSet, MceEventClassSetT>(
      this.set.bind(this),
      this.setLength(),
    );
    _o.reset = this.bb!.createObjList<EventKey, EventKeyT>(
      this.reset.bind(this),
      this.resetLength(),
    );
  }

  unpackFields(...fields: string[]): MceEventClassBatchT {
    const t = new MceEventClassBatchT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("set")) {
      t.set = this.bb!.createObjList<MceEventClassSet, MceEventClassSetT>(
        this.set.bind(this),
        this.setLength(),
      );
    }
    if (fieldSet.has("reset")) {
      t.reset = this.bb!.createObjList<EventKey, EventKeyT>(
        this.reset.bind(this),
        this.resetLength(),
      );
    }
    return t;
  }
}

export class MceEventClassBatchT implements flatbuffers.IGeneratedObject {
  constructor(
    public set: MceEventClassSetT[] = [],
    public reset: EventKeyT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const set = MceEventClassBatch.createSetVector(
      builder,
      builder.createObjectOffsetList(this.set),
    );
    const reset = builder.createStructOffsetList(this.reset, MceEventClassBatch.startResetVector);

    return MceEventClassBatch.createMceEventClassBatch(builder, set, reset);
  }

  clone(): MceEventClassBatchT {
    const obj = new MceEventClassBatchT();
    obj.set = this.set.map((e) => e.clone());
    obj.reset = this.reset.map((e) => e.clone());
    return obj;
  }

  equals(other: MceEventClassBatchT): boolean {
    if (this.set.length !== other.set.length) return false;
    for (let i = 0; i < this.set.length; i++) {
      const a = this.set[i];
      const b = other.set[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.reset.length !== other.reset.length) return false;
    for (let i = 0; i < this.reset.length; i++) {
      const a = this.reset[i];
      const b = other.reset[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyMceEventClassBatch(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMceEventClassSet);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
